export default "__VITE_ASSET__B_rWqLP2__"